import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Updates the PDP roast info banner when the selected variant changes.
 *
 * @typedef {Object} Refs
 * @property {HTMLElement} roastInfoContainer
 *
 * @extends {Component<Refs>}
 */
class CuppRoastInfoComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateRoastInfo);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateRoastInfo);
  }

  /**
   * @param {import('./events').VariantUpdateEvent} event
   */
  updateRoastInfo = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newComponent = event.detail.data.html.querySelector(
      `cupp-roast-info-component[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newComponent) {
      this.remove();
      return;
    }

    this.replaceWith(newComponent);
  };
}

if (!customElements.get('cupp-roast-info-component')) {
  customElements.define('cupp-roast-info-component', CuppRoastInfoComponent);
}
